import { IconButton, Tooltip } from "@mui/material";
import { Refresh } from "@mui/icons-material";

const RefreshButton = ({ onRefresh, disabled }: { onRefresh: () => any, disabled: boolean }) => {
    return (
        <Tooltip title="Refresh Data">
            <span>
                <IconButton onClick={onRefresh} disabled={disabled} >
                    <Refresh />
                </IconButton>
            </span>
        </Tooltip>
    )
}

export default RefreshButton;
